import {useContext,} from 'react';
import {Field, Panel} from '../../../../layouts';
import {QuoteTypes} from '../../../../types/enums';
import {formatShortDate, formatShortDateShortTime} from '../../../../utils/date-utils';
import {EstimateContext} from '../context/EstimateContext';

export default function EstimateInformationPanel() {

	const { order } = useContext(EstimateContext);

	const isLead = order.details.quoteTypeID === QuoteTypes.Lead;

	return (
		<>
			<Panel
				header={isLead ? 'Lead Information' : 'Estimate Information'}
			>
				<Field label={isLead ? 'Lead #' : 'Estimate #'} showCopyToClipboard={true} >{order.details.quoteNumber}</Field>
				<Field label={'Status'} >{order.details.status}</Field>
				<Field label={isLead ? 'Lead Date' : 'Estimate Date'} >{formatShortDate(order.details.quoteDate)}</Field>
				<Field label={isLead ? 'Lead Creation Date' : 'Estimate Creation Date'} >{formatShortDateShortTime(order.details.createdOn)}</Field>
				<Field label={'Payment URL'} showCopyToClipboard={true} visible={!isLead}>{order.details.paymentUrl}</Field>
			</Panel>
		</>
	);
}
